import { useSuspenseQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from 'src/constants';
import useApi from './useApi';

const useContributor = (memberName: string | undefined) => {
  const { contributorService } = useApi();
  const { data: contributor } = useSuspenseQuery({
    queryKey: QUERY_KEYS.contributor,
    queryFn: () => contributorService.get(memberName),
  });

  return { contributor };
};

export default useContributor;
